export default __webpack_public_path__ + "static/media/createOrganization.a810b16b.svg";